var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D8ACFB",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8515 25L13.5475 20.66V25H11.1535V15.172H13.5475V19.484L16.8235 15.172H19.6375L15.8295 19.988L19.7775 25H16.8515ZM29.8472 25H27.4532L23.4492 18.938V25H21.0552V15.172H23.4492L27.4532 21.262V15.172H29.8472V25Z",
    fill: "#D8ACFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamUser);
export default __webpack_public_path__ + "static/media/TeamUser.d03d73cd4d3134492652ab43408142dd.svg";
export { ForwardRef as ReactComponent };